/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { DraftUpdate } from '../../../../types/DraftUpdate';

export const DraftUpdateRequest: core.serialization.Schema<
    serializers.DraftUpdateRequest.Raw,
    Omit<Truvity.DraftUpdateRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    data: DraftUpdate,
});

export declare namespace DraftUpdateRequest {
    export interface Raw {
        data: DraftUpdate.Raw;
    }
}
